import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';

const SectionTitle = ({ title, subTitle, mb }) => (
  <Box display="block" mb={mb}>
    <Box font="h3-semibold" mb={3} as="h2">
      {title}
    </Box>
    {subTitle && (
      <Box font="body-regular-dove" mb={3} as="h6">
        {subTitle}
      </Box>
    )}
  </Box>
);

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  mb: PropTypes.number,
};

export default SectionTitle;
